import React from 'react';
import ProductPage from './ProductPage';

export default function BotMitigation() {
  return (
    <ProductPage
      badge="◍ Bot Mitigation"
      title="Catch bots that"
      titleAccent="never touch an ad"
      subtitle="Scrapers, crawlers, malicious AI, and automation tools pollute your analytics, inflate CPAs, and skew the data your optimisation runs on. ClickSaver flags them in real time."
      features={[
        { icon: '🤖', title: 'Behavioural fingerprinting', body: 'Detects headless browsers, residential proxies, and automation beyond simple user-agent checks.' },
        { icon: '◎', title: 'Datacenter &amp; VPN detection', body: 'Blocks traffic from hosting networks, Tor exits, and known VPN endpoints.' },
        { icon: '⚡', title: 'Session-behaviour signals', body: 'Scores scroll depth, mouse movement, dwell time, and click cadence to separate humans from scripts.' },
        { icon: '🔄', title: 'Continuous ML tuning', body: 'The model updates as new bot families emerge across our 10K+ customer base.' },
        { icon: '📊', title: 'Clean-analytics gate', body: 'Flagged sessions are excluded from your conversion pixels so GA4 and the ad platforms see real humans only.' },
        { icon: '🛡', title: 'Zero-config defaults', body: 'Out-of-the-box rules work for most sites. Tune per-campaign if you need to.' },
      ]}
      stats={[
        { value: '42%', label: 'of web traffic is bots (2024)' },
        { value: '2,000+', label: 'detection signals' },
        { value: '<1s', label: 'verdict latency' },
        { value: '99.4%', label: 'bot detection accuracy' },
      ]}
      ctaTitle="Keep your analytics honest"
      ctaBody="Bots cost you money even when they never click an ad. See the real humans in your funnel."
    />
  );
}
